const { VITE_PROJECTS_API } = import.meta.env;

/** The credentials the notification inbox signs in to Courier with. `user_id` is
 *  the id notifications are addressed to, so it must be passed to Courier as is. */
export interface NotificationsToken {
  user_id: string;
  token: string;
}

export const notificationsTokenPath = `${VITE_PROJECTS_API}/notifications/token`;
